export default "__VITE_ASSET__D5ah8EQa__"